export const FETCH_CREATE_DRAW = 'FETCH_CREATE_DRAW';
export const LIST_CREATE_DRAW = 'LIST_CREATE_DRAW';
export const MODIFIED_CREATE_DRAW = 'MODIFIED_CREATE_DRAW';
export const DELETE_CREATE_DRAW = 'DELETE_CREATE_DRAW';
export const CREATE_DRAW = 'CREATE_DRAW';
export const CLEAR_CREATE_DRAW = 'CLEAR_CREATE_DRAW';